import { useDispatch } from "react-redux"
import { setEfectivoIngresado } from "src/store/cortes/cortesSlice"

export function useEfectivo() {
    const dispatch = useDispatch()

    // El monto se guarda en localStorage para sobrevivir un refresh dentro del mismo
    // corte, asi que hay que limpiar las dos copias o el valor reaparece al recargar.
    const onClearEfectivo = () => {
        localStorage.removeItem("efectivoIngresado")
        dispatch(setEfectivoIngresado(0))
    }

    return {
        onClearEfectivo
    }
}
